/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as InvitesRouteRouteImport } from './routes/invites/route'
import { Route as dashboardRouteRouteImport } from './routes/(dashboard)/route'
import { Route as dashboardIndexRouteImport } from './routes/(dashboard)/index'
import { Route as OnboardingBlankRouteImport } from './routes/onboarding/_blank'
import { Route as InvitesBlankRouteImport } from './routes/invites/_blank'
import { Route as dashboardDirectReportsRouteRouteImport } from './routes/(dashboard)/direct-reports/route'
import { Route as dashboardAssessmentsRouteRouteImport } from './routes/(dashboard)/assessments/route'
import { Route as OnboardingBlankIndexRouteImport } from './routes/onboarding/_blank.index'
import { Route as dashboardSettingsIndexRouteImport } from './routes/(dashboard)/settings/index'
import { Route as dashboardPositionsIndexRouteImport } from './routes/(dashboard)/positions/index'
import { Route as dashboardDirectReportsIndexRouteImport } from './routes/(dashboard)/direct-reports/index'
import { Route as dashboardAssessmentsIndexRouteImport } from './routes/(dashboard)/assessments/index'
import { Route as dashboardAdminIndexRouteImport } from './routes/(dashboard)/admin/index'
import { Route as OnboardingBlankAssignPositionRouteImport } from './routes/onboarding/_blank.assign-position'
import { Route as dashboardDirectReportsDirectReportIdRouteRouteImport } from './routes/(dashboard)/direct-reports/$directReportId/route'
import { Route as dashboardAssessmentsAssessmentIdRouteRouteImport } from './routes/(dashboard)/assessments/$assessmentId/route'
import { Route as dashboardOrganizationSettingsIndexRouteImport } from './routes/(dashboard)/organization/settings/index'
import { Route as dashboardOrganizationOverviewIndexRouteImport } from './routes/(dashboard)/organization/overview/index'
import { Route as dashboardOrganizationInvitesIndexRouteImport } from './routes/(dashboard)/organization/invites/index'
import { Route as dashboardOrganizationBillingIndexRouteImport } from './routes/(dashboard)/organization/billing/index'
import { Route as dashboardDirectReportsInvitedIndexRouteImport } from './routes/(dashboard)/direct-reports/invited/index'
import { Route as dashboardAssessmentsDirectReportsIndexRouteImport } from './routes/(dashboard)/assessments/direct-reports/index'
import { Route as dashboardAssessmentsAssessmentIdIndexRouteImport } from './routes/(dashboard)/assessments/$assessmentId/index'
import { Route as dashboardAnalyticsStatisticsIndexRouteImport } from './routes/(dashboard)/analytics/statistics/index'
import { Route as dashboardAnalyticsOverviewIndexRouteImport } from './routes/(dashboard)/analytics/overview/index'
import { Route as dashboardAdminUsersIndexRouteImport } from './routes/(dashboard)/admin/users/index'
import { Route as dashboardAdminOrganizationsIndexRouteImport } from './routes/(dashboard)/admin/organizations/index'
import { Route as InvitesBlankIdConfirmRouteImport } from './routes/invites/_blank.$id.confirm'
import { Route as dashboardPositionsIdQuestionsRouteImport } from './routes/(dashboard)/positions/$id.questions'
import { Route as dashboardAdminUsersUserIdRouteRouteImport } from './routes/(dashboard)/admin/users/$userId/route'
import { Route as dashboardAdminOrganizationsOrganizationIdRouteRouteImport } from './routes/(dashboard)/admin/organizations/$organizationId/route'
import { Route as dashboardDirectReportsDirectReportIdUserSettingsIndexRouteImport } from './routes/(dashboard)/direct-reports/$directReportId/user-settings/index'
import { Route as dashboardDirectReportsDirectReportIdCareerPathIndexRouteImport } from './routes/(dashboard)/direct-reports/$directReportId/career-path/index'
import { Route as dashboardDirectReportsDirectReportIdAssessmentsIndexRouteImport } from './routes/(dashboard)/direct-reports/$directReportId/assessments/index'
import { Route as dashboardAdminUsersUserIdIndexRouteImport } from './routes/(dashboard)/admin/users/$userId/index'
import { Route as dashboardAdminOrganizationsOrganizationIdIndexRouteImport } from './routes/(dashboard)/admin/organizations/$organizationId/index'
import { Route as dashboardAssessmentsAssessmentIdResponsesIdRouteImport } from './routes/(dashboard)/assessments/$assessmentId/responses/$id'
import { Route as dashboardAdminUsersUserIdSettingsIndexRouteImport } from './routes/(dashboard)/admin/users/$userId/settings/index'
import { Route as dashboardAdminUsersUserIdOrganizationsIndexRouteImport } from './routes/(dashboard)/admin/users/$userId/organizations/index'
import { Route as dashboardAdminOrganizationsOrganizationIdSettingsIndexRouteImport } from './routes/(dashboard)/admin/organizations/$organizationId/settings/index'
import { Route as dashboardAdminOrganizationsOrganizationIdMembersIndexRouteImport } from './routes/(dashboard)/admin/organizations/$organizationId/members/index'
import { Route as dashboardAdminOrganizationsOrganizationIdBillingIndexRouteImport } from './routes/(dashboard)/admin/organizations/$organizationId/billing/index'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesRouteRoute = InvitesRouteRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardRouteRoute = dashboardRouteRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardIndexRoute = dashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const OnboardingBlankRoute = OnboardingBlankRouteImport.update({
  id: '/onboarding/_blank',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesBlankRoute = InvitesBlankRouteImport.update({
  id: '/_blank',
  getParentRoute: () => InvitesRouteRoute,
} as any)
const dashboardDirectReportsRouteRoute =
  dashboardDirectReportsRouteRouteImport.update({
    id: '/direct-reports',
    path: '/direct-reports',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardAssessmentsRouteRoute =
  dashboardAssessmentsRouteRouteImport.update({
    id: '/assessments',
    path: '/assessments',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const OnboardingBlankIndexRoute = OnboardingBlankIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingBlankRoute,
} as any)
const dashboardSettingsIndexRoute = dashboardSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardPositionsIndexRoute = dashboardPositionsIndexRouteImport.update({
  id: '/positions/',
  path: '/positions/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardDirectReportsIndexRoute =
  dashboardDirectReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDirectReportsRouteRoute,
  } as any)
const dashboardAssessmentsIndexRoute =
  dashboardAssessmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardAssessmentsRouteRoute,
  } as any)
const dashboardAdminIndexRoute = dashboardAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const OnboardingBlankAssignPositionRoute =
  OnboardingBlankAssignPositionRouteImport.update({
    id: '/assign-position',
    path: '/assign-position',
    getParentRoute: () => OnboardingBlankRoute,
  } as any)
const dashboardDirectReportsDirectReportIdRouteRoute =
  dashboardDirectReportsDirectReportIdRouteRouteImport.update({
    id: '/$directReportId',
    path: '/$directReportId',
    getParentRoute: () => dashboardDirectReportsRouteRoute,
  } as any)
const dashboardAssessmentsAssessmentIdRouteRoute =
  dashboardAssessmentsAssessmentIdRouteRouteImport.update({
    id: '/$assessmentId',
    path: '/$assessmentId',
    getParentRoute: () => dashboardAssessmentsRouteRoute,
  } as any)
const dashboardOrganizationSettingsIndexRoute =
  dashboardOrganizationSettingsIndexRouteImport.update({
    id: '/organization/settings/',
    path: '/organization/settings/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardOrganizationOverviewIndexRoute =
  dashboardOrganizationOverviewIndexRouteImport.update({
    id: '/organization/overview/',
    path: '/organization/overview/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardOrganizationInvitesIndexRoute =
  dashboardOrganizationInvitesIndexRouteImport.update({
    id: '/organization/invites/',
    path: '/organization/invites/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardOrganizationBillingIndexRoute =
  dashboardOrganizationBillingIndexRouteImport.update({
    id: '/organization/billing/',
    path: '/organization/billing/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDirectReportsInvitedIndexRoute =
  dashboardDirectReportsInvitedIndexRouteImport.update({
    id: '/invited/',
    path: '/invited/',
    getParentRoute: () => dashboardDirectReportsRouteRoute,
  } as any)
const dashboardAssessmentsDirectReportsIndexRoute =
  dashboardAssessmentsDirectReportsIndexRouteImport.update({
    id: '/direct-reports/',
    path: '/direct-reports/',
    getParentRoute: () => dashboardAssessmentsRouteRoute,
  } as any)
const dashboardAssessmentsAssessmentIdIndexRoute =
  dashboardAssessmentsAssessmentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardAssessmentsAssessmentIdRouteRoute,
  } as any)
const dashboardAnalyticsStatisticsIndexRoute =
  dashboardAnalyticsStatisticsIndexRouteImport.update({
    id: '/analytics/statistics/',
    path: '/analytics/statistics/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardAnalyticsOverviewIndexRoute =
  dashboardAnalyticsOverviewIndexRouteImport.update({
    id: '/analytics/overview/',
    path: '/analytics/overview/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardAdminUsersIndexRoute =
  dashboardAdminUsersIndexRouteImport.update({
    id: '/admin/users/',
    path: '/admin/users/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardAdminOrganizationsIndexRoute =
  dashboardAdminOrganizationsIndexRouteImport.update({
    id: '/admin/organizations/',
    path: '/admin/organizations/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const InvitesBlankIdConfirmRoute = InvitesBlankIdConfirmRouteImport.update({
  id: '/$id/confirm',
  path: '/$id/confirm',
  getParentRoute: () => InvitesBlankRoute,
} as any)
const dashboardPositionsIdQuestionsRoute =
  dashboardPositionsIdQuestionsRouteImport.update({
    id: '/positions/$id/questions',
    path: '/positions/$id/questions',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardAdminUsersUserIdRouteRoute =
  dashboardAdminUsersUserIdRouteRouteImport.update({
    id: '/admin/users/$userId',
    path: '/admin/users/$userId',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardAdminOrganizationsOrganizationIdRouteRoute =
  dashboardAdminOrganizationsOrganizationIdRouteRouteImport.update({
    id: '/admin/organizations/$organizationId',
    path: '/admin/organizations/$organizationId',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDirectReportsDirectReportIdUserSettingsIndexRoute =
  dashboardDirectReportsDirectReportIdUserSettingsIndexRouteImport.update({
    id: '/user-settings/',
    path: '/user-settings/',
    getParentRoute: () => dashboardDirectReportsDirectReportIdRouteRoute,
  } as any)
const dashboardDirectReportsDirectReportIdCareerPathIndexRoute =
  dashboardDirectReportsDirectReportIdCareerPathIndexRouteImport.update({
    id: '/career-path/',
    path: '/career-path/',
    getParentRoute: () => dashboardDirectReportsDirectReportIdRouteRoute,
  } as any)
const dashboardDirectReportsDirectReportIdAssessmentsIndexRoute =
  dashboardDirectReportsDirectReportIdAssessmentsIndexRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => dashboardDirectReportsDirectReportIdRouteRoute,
  } as any)
const dashboardAdminUsersUserIdIndexRoute =
  dashboardAdminUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardAdminUsersUserIdRouteRoute,
  } as any)
const dashboardAdminOrganizationsOrganizationIdIndexRoute =
  dashboardAdminOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardAdminOrganizationsOrganizationIdRouteRoute,
  } as any)
const dashboardAssessmentsAssessmentIdResponsesIdRoute =
  dashboardAssessmentsAssessmentIdResponsesIdRouteImport.update({
    id: '/responses/$id',
    path: '/responses/$id',
    getParentRoute: () => dashboardAssessmentsAssessmentIdRouteRoute,
  } as any)
const dashboardAdminUsersUserIdSettingsIndexRoute =
  dashboardAdminUsersUserIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => dashboardAdminUsersUserIdRouteRoute,
  } as any)
const dashboardAdminUsersUserIdOrganizationsIndexRoute =
  dashboardAdminUsersUserIdOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => dashboardAdminUsersUserIdRouteRoute,
  } as any)
const dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute =
  dashboardAdminOrganizationsOrganizationIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => dashboardAdminOrganizationsOrganizationIdRouteRoute,
  } as any)
const dashboardAdminOrganizationsOrganizationIdMembersIndexRoute =
  dashboardAdminOrganizationsOrganizationIdMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => dashboardAdminOrganizationsOrganizationIdRouteRoute,
  } as any)
const dashboardAdminOrganizationsOrganizationIdBillingIndexRoute =
  dashboardAdminOrganizationsOrganizationIdBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => dashboardAdminOrganizationsOrganizationIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/invites': typeof InvitesBlankRouteWithChildren
  '/callback': typeof CallbackRoute
  '/sign-in': typeof SignInRoute
  '/assessments': typeof dashboardAssessmentsRouteRouteWithChildren
  '/direct-reports': typeof dashboardDirectReportsRouteRouteWithChildren
  '/onboarding': typeof OnboardingBlankRouteWithChildren
  '/': typeof dashboardIndexRoute
  '/assessments/$assessmentId': typeof dashboardAssessmentsAssessmentIdRouteRouteWithChildren
  '/direct-reports/$directReportId': typeof dashboardDirectReportsDirectReportIdRouteRouteWithChildren
  '/onboarding/assign-position': typeof OnboardingBlankAssignPositionRoute
  '/admin/': typeof dashboardAdminIndexRoute
  '/assessments/': typeof dashboardAssessmentsIndexRoute
  '/direct-reports/': typeof dashboardDirectReportsIndexRoute
  '/positions/': typeof dashboardPositionsIndexRoute
  '/settings/': typeof dashboardSettingsIndexRoute
  '/onboarding/': typeof OnboardingBlankIndexRoute
  '/admin/organizations/$organizationId': typeof dashboardAdminOrganizationsOrganizationIdRouteRouteWithChildren
  '/admin/users/$userId': typeof dashboardAdminUsersUserIdRouteRouteWithChildren
  '/positions/$id/questions': typeof dashboardPositionsIdQuestionsRoute
  '/invites/$id/confirm': typeof InvitesBlankIdConfirmRoute
  '/admin/organizations/': typeof dashboardAdminOrganizationsIndexRoute
  '/admin/users/': typeof dashboardAdminUsersIndexRoute
  '/analytics/overview/': typeof dashboardAnalyticsOverviewIndexRoute
  '/analytics/statistics/': typeof dashboardAnalyticsStatisticsIndexRoute
  '/assessments/$assessmentId/': typeof dashboardAssessmentsAssessmentIdIndexRoute
  '/assessments/direct-reports/': typeof dashboardAssessmentsDirectReportsIndexRoute
  '/direct-reports/invited/': typeof dashboardDirectReportsInvitedIndexRoute
  '/organization/billing/': typeof dashboardOrganizationBillingIndexRoute
  '/organization/invites/': typeof dashboardOrganizationInvitesIndexRoute
  '/organization/overview/': typeof dashboardOrganizationOverviewIndexRoute
  '/organization/settings/': typeof dashboardOrganizationSettingsIndexRoute
  '/assessments/$assessmentId/responses/$id': typeof dashboardAssessmentsAssessmentIdResponsesIdRoute
  '/admin/organizations/$organizationId/': typeof dashboardAdminOrganizationsOrganizationIdIndexRoute
  '/admin/users/$userId/': typeof dashboardAdminUsersUserIdIndexRoute
  '/direct-reports/$directReportId/assessments/': typeof dashboardDirectReportsDirectReportIdAssessmentsIndexRoute
  '/direct-reports/$directReportId/career-path/': typeof dashboardDirectReportsDirectReportIdCareerPathIndexRoute
  '/direct-reports/$directReportId/user-settings/': typeof dashboardDirectReportsDirectReportIdUserSettingsIndexRoute
  '/admin/organizations/$organizationId/billing/': typeof dashboardAdminOrganizationsOrganizationIdBillingIndexRoute
  '/admin/organizations/$organizationId/members/': typeof dashboardAdminOrganizationsOrganizationIdMembersIndexRoute
  '/admin/organizations/$organizationId/settings/': typeof dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute
  '/admin/users/$userId/organizations/': typeof dashboardAdminUsersUserIdOrganizationsIndexRoute
  '/admin/users/$userId/settings/': typeof dashboardAdminUsersUserIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/invites': typeof InvitesBlankRouteWithChildren
  '/callback': typeof CallbackRoute
  '/sign-in': typeof SignInRoute
  '/': typeof dashboardIndexRoute
  '/direct-reports/$directReportId': typeof dashboardDirectReportsDirectReportIdRouteRouteWithChildren
  '/onboarding/assign-position': typeof OnboardingBlankAssignPositionRoute
  '/admin': typeof dashboardAdminIndexRoute
  '/assessments': typeof dashboardAssessmentsIndexRoute
  '/direct-reports': typeof dashboardDirectReportsIndexRoute
  '/positions': typeof dashboardPositionsIndexRoute
  '/settings': typeof dashboardSettingsIndexRoute
  '/onboarding': typeof OnboardingBlankIndexRoute
  '/positions/$id/questions': typeof dashboardPositionsIdQuestionsRoute
  '/invites/$id/confirm': typeof InvitesBlankIdConfirmRoute
  '/admin/organizations': typeof dashboardAdminOrganizationsIndexRoute
  '/admin/users': typeof dashboardAdminUsersIndexRoute
  '/analytics/overview': typeof dashboardAnalyticsOverviewIndexRoute
  '/analytics/statistics': typeof dashboardAnalyticsStatisticsIndexRoute
  '/assessments/$assessmentId': typeof dashboardAssessmentsAssessmentIdIndexRoute
  '/assessments/direct-reports': typeof dashboardAssessmentsDirectReportsIndexRoute
  '/direct-reports/invited': typeof dashboardDirectReportsInvitedIndexRoute
  '/organization/billing': typeof dashboardOrganizationBillingIndexRoute
  '/organization/invites': typeof dashboardOrganizationInvitesIndexRoute
  '/organization/overview': typeof dashboardOrganizationOverviewIndexRoute
  '/organization/settings': typeof dashboardOrganizationSettingsIndexRoute
  '/assessments/$assessmentId/responses/$id': typeof dashboardAssessmentsAssessmentIdResponsesIdRoute
  '/admin/organizations/$organizationId': typeof dashboardAdminOrganizationsOrganizationIdIndexRoute
  '/admin/users/$userId': typeof dashboardAdminUsersUserIdIndexRoute
  '/direct-reports/$directReportId/assessments': typeof dashboardDirectReportsDirectReportIdAssessmentsIndexRoute
  '/direct-reports/$directReportId/career-path': typeof dashboardDirectReportsDirectReportIdCareerPathIndexRoute
  '/direct-reports/$directReportId/user-settings': typeof dashboardDirectReportsDirectReportIdUserSettingsIndexRoute
  '/admin/organizations/$organizationId/billing': typeof dashboardAdminOrganizationsOrganizationIdBillingIndexRoute
  '/admin/organizations/$organizationId/members': typeof dashboardAdminOrganizationsOrganizationIdMembersIndexRoute
  '/admin/organizations/$organizationId/settings': typeof dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute
  '/admin/users/$userId/organizations': typeof dashboardAdminUsersUserIdOrganizationsIndexRoute
  '/admin/users/$userId/settings': typeof dashboardAdminUsersUserIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(dashboard)': typeof dashboardRouteRouteWithChildren
  '/invites': typeof InvitesRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/sign-in': typeof SignInRoute
  '/(dashboard)/assessments': typeof dashboardAssessmentsRouteRouteWithChildren
  '/(dashboard)/direct-reports': typeof dashboardDirectReportsRouteRouteWithChildren
  '/invites/_blank': typeof InvitesBlankRouteWithChildren
  '/onboarding/_blank': typeof OnboardingBlankRouteWithChildren
  '/(dashboard)/': typeof dashboardIndexRoute
  '/(dashboard)/assessments/$assessmentId': typeof dashboardAssessmentsAssessmentIdRouteRouteWithChildren
  '/(dashboard)/direct-reports/$directReportId': typeof dashboardDirectReportsDirectReportIdRouteRouteWithChildren
  '/onboarding/_blank/assign-position': typeof OnboardingBlankAssignPositionRoute
  '/(dashboard)/admin/': typeof dashboardAdminIndexRoute
  '/(dashboard)/assessments/': typeof dashboardAssessmentsIndexRoute
  '/(dashboard)/direct-reports/': typeof dashboardDirectReportsIndexRoute
  '/(dashboard)/positions/': typeof dashboardPositionsIndexRoute
  '/(dashboard)/settings/': typeof dashboardSettingsIndexRoute
  '/onboarding/_blank/': typeof OnboardingBlankIndexRoute
  '/(dashboard)/admin/organizations/$organizationId': typeof dashboardAdminOrganizationsOrganizationIdRouteRouteWithChildren
  '/(dashboard)/admin/users/$userId': typeof dashboardAdminUsersUserIdRouteRouteWithChildren
  '/(dashboard)/positions/$id/questions': typeof dashboardPositionsIdQuestionsRoute
  '/invites/_blank/$id/confirm': typeof InvitesBlankIdConfirmRoute
  '/(dashboard)/admin/organizations/': typeof dashboardAdminOrganizationsIndexRoute
  '/(dashboard)/admin/users/': typeof dashboardAdminUsersIndexRoute
  '/(dashboard)/analytics/overview/': typeof dashboardAnalyticsOverviewIndexRoute
  '/(dashboard)/analytics/statistics/': typeof dashboardAnalyticsStatisticsIndexRoute
  '/(dashboard)/assessments/$assessmentId/': typeof dashboardAssessmentsAssessmentIdIndexRoute
  '/(dashboard)/assessments/direct-reports/': typeof dashboardAssessmentsDirectReportsIndexRoute
  '/(dashboard)/direct-reports/invited/': typeof dashboardDirectReportsInvitedIndexRoute
  '/(dashboard)/organization/billing/': typeof dashboardOrganizationBillingIndexRoute
  '/(dashboard)/organization/invites/': typeof dashboardOrganizationInvitesIndexRoute
  '/(dashboard)/organization/overview/': typeof dashboardOrganizationOverviewIndexRoute
  '/(dashboard)/organization/settings/': typeof dashboardOrganizationSettingsIndexRoute
  '/(dashboard)/assessments/$assessmentId/responses/$id': typeof dashboardAssessmentsAssessmentIdResponsesIdRoute
  '/(dashboard)/admin/organizations/$organizationId/': typeof dashboardAdminOrganizationsOrganizationIdIndexRoute
  '/(dashboard)/admin/users/$userId/': typeof dashboardAdminUsersUserIdIndexRoute
  '/(dashboard)/direct-reports/$directReportId/assessments/': typeof dashboardDirectReportsDirectReportIdAssessmentsIndexRoute
  '/(dashboard)/direct-reports/$directReportId/career-path/': typeof dashboardDirectReportsDirectReportIdCareerPathIndexRoute
  '/(dashboard)/direct-reports/$directReportId/user-settings/': typeof dashboardDirectReportsDirectReportIdUserSettingsIndexRoute
  '/(dashboard)/admin/organizations/$organizationId/billing/': typeof dashboardAdminOrganizationsOrganizationIdBillingIndexRoute
  '/(dashboard)/admin/organizations/$organizationId/members/': typeof dashboardAdminOrganizationsOrganizationIdMembersIndexRoute
  '/(dashboard)/admin/organizations/$organizationId/settings/': typeof dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute
  '/(dashboard)/admin/users/$userId/organizations/': typeof dashboardAdminUsersUserIdOrganizationsIndexRoute
  '/(dashboard)/admin/users/$userId/settings/': typeof dashboardAdminUsersUserIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/invites'
    | '/callback'
    | '/sign-in'
    | '/assessments'
    | '/direct-reports'
    | '/onboarding'
    | '/'
    | '/assessments/$assessmentId'
    | '/direct-reports/$directReportId'
    | '/onboarding/assign-position'
    | '/admin/'
    | '/assessments/'
    | '/direct-reports/'
    | '/positions/'
    | '/settings/'
    | '/onboarding/'
    | '/admin/organizations/$organizationId'
    | '/admin/users/$userId'
    | '/positions/$id/questions'
    | '/invites/$id/confirm'
    | '/admin/organizations/'
    | '/admin/users/'
    | '/analytics/overview/'
    | '/analytics/statistics/'
    | '/assessments/$assessmentId/'
    | '/assessments/direct-reports/'
    | '/direct-reports/invited/'
    | '/organization/billing/'
    | '/organization/invites/'
    | '/organization/overview/'
    | '/organization/settings/'
    | '/assessments/$assessmentId/responses/$id'
    | '/admin/organizations/$organizationId/'
    | '/admin/users/$userId/'
    | '/direct-reports/$directReportId/assessments/'
    | '/direct-reports/$directReportId/career-path/'
    | '/direct-reports/$directReportId/user-settings/'
    | '/admin/organizations/$organizationId/billing/'
    | '/admin/organizations/$organizationId/members/'
    | '/admin/organizations/$organizationId/settings/'
    | '/admin/users/$userId/organizations/'
    | '/admin/users/$userId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/invites'
    | '/callback'
    | '/sign-in'
    | '/'
    | '/direct-reports/$directReportId'
    | '/onboarding/assign-position'
    | '/admin'
    | '/assessments'
    | '/direct-reports'
    | '/positions'
    | '/settings'
    | '/onboarding'
    | '/positions/$id/questions'
    | '/invites/$id/confirm'
    | '/admin/organizations'
    | '/admin/users'
    | '/analytics/overview'
    | '/analytics/statistics'
    | '/assessments/$assessmentId'
    | '/assessments/direct-reports'
    | '/direct-reports/invited'
    | '/organization/billing'
    | '/organization/invites'
    | '/organization/overview'
    | '/organization/settings'
    | '/assessments/$assessmentId/responses/$id'
    | '/admin/organizations/$organizationId'
    | '/admin/users/$userId'
    | '/direct-reports/$directReportId/assessments'
    | '/direct-reports/$directReportId/career-path'
    | '/direct-reports/$directReportId/user-settings'
    | '/admin/organizations/$organizationId/billing'
    | '/admin/organizations/$organizationId/members'
    | '/admin/organizations/$organizationId/settings'
    | '/admin/users/$userId/organizations'
    | '/admin/users/$userId/settings'
  id:
    | '__root__'
    | '/(dashboard)'
    | '/invites'
    | '/callback'
    | '/sign-in'
    | '/(dashboard)/assessments'
    | '/(dashboard)/direct-reports'
    | '/invites/_blank'
    | '/onboarding/_blank'
    | '/(dashboard)/'
    | '/(dashboard)/assessments/$assessmentId'
    | '/(dashboard)/direct-reports/$directReportId'
    | '/onboarding/_blank/assign-position'
    | '/(dashboard)/admin/'
    | '/(dashboard)/assessments/'
    | '/(dashboard)/direct-reports/'
    | '/(dashboard)/positions/'
    | '/(dashboard)/settings/'
    | '/onboarding/_blank/'
    | '/(dashboard)/admin/organizations/$organizationId'
    | '/(dashboard)/admin/users/$userId'
    | '/(dashboard)/positions/$id/questions'
    | '/invites/_blank/$id/confirm'
    | '/(dashboard)/admin/organizations/'
    | '/(dashboard)/admin/users/'
    | '/(dashboard)/analytics/overview/'
    | '/(dashboard)/analytics/statistics/'
    | '/(dashboard)/assessments/$assessmentId/'
    | '/(dashboard)/assessments/direct-reports/'
    | '/(dashboard)/direct-reports/invited/'
    | '/(dashboard)/organization/billing/'
    | '/(dashboard)/organization/invites/'
    | '/(dashboard)/organization/overview/'
    | '/(dashboard)/organization/settings/'
    | '/(dashboard)/assessments/$assessmentId/responses/$id'
    | '/(dashboard)/admin/organizations/$organizationId/'
    | '/(dashboard)/admin/users/$userId/'
    | '/(dashboard)/direct-reports/$directReportId/assessments/'
    | '/(dashboard)/direct-reports/$directReportId/career-path/'
    | '/(dashboard)/direct-reports/$directReportId/user-settings/'
    | '/(dashboard)/admin/organizations/$organizationId/billing/'
    | '/(dashboard)/admin/organizations/$organizationId/members/'
    | '/(dashboard)/admin/organizations/$organizationId/settings/'
    | '/(dashboard)/admin/users/$userId/organizations/'
    | '/(dashboard)/admin/users/$userId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  dashboardRouteRoute: typeof dashboardRouteRouteWithChildren
  InvitesRouteRoute: typeof InvitesRouteRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  SignInRoute: typeof SignInRoute
  OnboardingBlankRoute: typeof OnboardingBlankRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites': {
      id: '/invites'
      path: '/invites'
      fullPath: '/invites'
      preLoaderRoute: typeof InvitesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)': {
      id: '/(dashboard)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof dashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/': {
      id: '/(dashboard)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/onboarding/_blank': {
      id: '/onboarding/_blank'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingBlankRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/_blank': {
      id: '/invites/_blank'
      path: ''
      fullPath: '/invites'
      preLoaderRoute: typeof InvitesBlankRouteImport
      parentRoute: typeof InvitesRouteRoute
    }
    '/(dashboard)/direct-reports': {
      id: '/(dashboard)/direct-reports'
      path: '/direct-reports'
      fullPath: '/direct-reports'
      preLoaderRoute: typeof dashboardDirectReportsRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/assessments': {
      id: '/(dashboard)/assessments'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof dashboardAssessmentsRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/onboarding/_blank/': {
      id: '/onboarding/_blank/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingBlankIndexRouteImport
      parentRoute: typeof OnboardingBlankRoute
    }
    '/(dashboard)/settings/': {
      id: '/(dashboard)/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof dashboardSettingsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/positions/': {
      id: '/(dashboard)/positions/'
      path: '/positions'
      fullPath: '/positions/'
      preLoaderRoute: typeof dashboardPositionsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/direct-reports/': {
      id: '/(dashboard)/direct-reports/'
      path: '/'
      fullPath: '/direct-reports/'
      preLoaderRoute: typeof dashboardDirectReportsIndexRouteImport
      parentRoute: typeof dashboardDirectReportsRouteRoute
    }
    '/(dashboard)/assessments/': {
      id: '/(dashboard)/assessments/'
      path: '/'
      fullPath: '/assessments/'
      preLoaderRoute: typeof dashboardAssessmentsIndexRouteImport
      parentRoute: typeof dashboardAssessmentsRouteRoute
    }
    '/(dashboard)/admin/': {
      id: '/(dashboard)/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof dashboardAdminIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/onboarding/_blank/assign-position': {
      id: '/onboarding/_blank/assign-position'
      path: '/assign-position'
      fullPath: '/onboarding/assign-position'
      preLoaderRoute: typeof OnboardingBlankAssignPositionRouteImport
      parentRoute: typeof OnboardingBlankRoute
    }
    '/(dashboard)/direct-reports/$directReportId': {
      id: '/(dashboard)/direct-reports/$directReportId'
      path: '/$directReportId'
      fullPath: '/direct-reports/$directReportId'
      preLoaderRoute: typeof dashboardDirectReportsDirectReportIdRouteRouteImport
      parentRoute: typeof dashboardDirectReportsRouteRoute
    }
    '/(dashboard)/assessments/$assessmentId': {
      id: '/(dashboard)/assessments/$assessmentId'
      path: '/$assessmentId'
      fullPath: '/assessments/$assessmentId'
      preLoaderRoute: typeof dashboardAssessmentsAssessmentIdRouteRouteImport
      parentRoute: typeof dashboardAssessmentsRouteRoute
    }
    '/(dashboard)/organization/settings/': {
      id: '/(dashboard)/organization/settings/'
      path: '/organization/settings'
      fullPath: '/organization/settings/'
      preLoaderRoute: typeof dashboardOrganizationSettingsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/organization/overview/': {
      id: '/(dashboard)/organization/overview/'
      path: '/organization/overview'
      fullPath: '/organization/overview/'
      preLoaderRoute: typeof dashboardOrganizationOverviewIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/organization/invites/': {
      id: '/(dashboard)/organization/invites/'
      path: '/organization/invites'
      fullPath: '/organization/invites/'
      preLoaderRoute: typeof dashboardOrganizationInvitesIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/organization/billing/': {
      id: '/(dashboard)/organization/billing/'
      path: '/organization/billing'
      fullPath: '/organization/billing/'
      preLoaderRoute: typeof dashboardOrganizationBillingIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/direct-reports/invited/': {
      id: '/(dashboard)/direct-reports/invited/'
      path: '/invited'
      fullPath: '/direct-reports/invited/'
      preLoaderRoute: typeof dashboardDirectReportsInvitedIndexRouteImport
      parentRoute: typeof dashboardDirectReportsRouteRoute
    }
    '/(dashboard)/assessments/direct-reports/': {
      id: '/(dashboard)/assessments/direct-reports/'
      path: '/direct-reports'
      fullPath: '/assessments/direct-reports/'
      preLoaderRoute: typeof dashboardAssessmentsDirectReportsIndexRouteImport
      parentRoute: typeof dashboardAssessmentsRouteRoute
    }
    '/(dashboard)/assessments/$assessmentId/': {
      id: '/(dashboard)/assessments/$assessmentId/'
      path: '/'
      fullPath: '/assessments/$assessmentId/'
      preLoaderRoute: typeof dashboardAssessmentsAssessmentIdIndexRouteImport
      parentRoute: typeof dashboardAssessmentsAssessmentIdRouteRoute
    }
    '/(dashboard)/analytics/statistics/': {
      id: '/(dashboard)/analytics/statistics/'
      path: '/analytics/statistics'
      fullPath: '/analytics/statistics/'
      preLoaderRoute: typeof dashboardAnalyticsStatisticsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/analytics/overview/': {
      id: '/(dashboard)/analytics/overview/'
      path: '/analytics/overview'
      fullPath: '/analytics/overview/'
      preLoaderRoute: typeof dashboardAnalyticsOverviewIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/admin/users/': {
      id: '/(dashboard)/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof dashboardAdminUsersIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/admin/organizations/': {
      id: '/(dashboard)/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof dashboardAdminOrganizationsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/invites/_blank/$id/confirm': {
      id: '/invites/_blank/$id/confirm'
      path: '/$id/confirm'
      fullPath: '/invites/$id/confirm'
      preLoaderRoute: typeof InvitesBlankIdConfirmRouteImport
      parentRoute: typeof InvitesBlankRoute
    }
    '/(dashboard)/positions/$id/questions': {
      id: '/(dashboard)/positions/$id/questions'
      path: '/positions/$id/questions'
      fullPath: '/positions/$id/questions'
      preLoaderRoute: typeof dashboardPositionsIdQuestionsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/admin/users/$userId': {
      id: '/(dashboard)/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof dashboardAdminUsersUserIdRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/admin/organizations/$organizationId': {
      id: '/(dashboard)/admin/organizations/$organizationId'
      path: '/admin/organizations/$organizationId'
      fullPath: '/admin/organizations/$organizationId'
      preLoaderRoute: typeof dashboardAdminOrganizationsOrganizationIdRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/direct-reports/$directReportId/user-settings/': {
      id: '/(dashboard)/direct-reports/$directReportId/user-settings/'
      path: '/user-settings'
      fullPath: '/direct-reports/$directReportId/user-settings/'
      preLoaderRoute: typeof dashboardDirectReportsDirectReportIdUserSettingsIndexRouteImport
      parentRoute: typeof dashboardDirectReportsDirectReportIdRouteRoute
    }
    '/(dashboard)/direct-reports/$directReportId/career-path/': {
      id: '/(dashboard)/direct-reports/$directReportId/career-path/'
      path: '/career-path'
      fullPath: '/direct-reports/$directReportId/career-path/'
      preLoaderRoute: typeof dashboardDirectReportsDirectReportIdCareerPathIndexRouteImport
      parentRoute: typeof dashboardDirectReportsDirectReportIdRouteRoute
    }
    '/(dashboard)/direct-reports/$directReportId/assessments/': {
      id: '/(dashboard)/direct-reports/$directReportId/assessments/'
      path: '/assessments'
      fullPath: '/direct-reports/$directReportId/assessments/'
      preLoaderRoute: typeof dashboardDirectReportsDirectReportIdAssessmentsIndexRouteImport
      parentRoute: typeof dashboardDirectReportsDirectReportIdRouteRoute
    }
    '/(dashboard)/admin/users/$userId/': {
      id: '/(dashboard)/admin/users/$userId/'
      path: '/'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof dashboardAdminUsersUserIdIndexRouteImport
      parentRoute: typeof dashboardAdminUsersUserIdRouteRoute
    }
    '/(dashboard)/admin/organizations/$organizationId/': {
      id: '/(dashboard)/admin/organizations/$organizationId/'
      path: '/'
      fullPath: '/admin/organizations/$organizationId/'
      preLoaderRoute: typeof dashboardAdminOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof dashboardAdminOrganizationsOrganizationIdRouteRoute
    }
    '/(dashboard)/assessments/$assessmentId/responses/$id': {
      id: '/(dashboard)/assessments/$assessmentId/responses/$id'
      path: '/responses/$id'
      fullPath: '/assessments/$assessmentId/responses/$id'
      preLoaderRoute: typeof dashboardAssessmentsAssessmentIdResponsesIdRouteImport
      parentRoute: typeof dashboardAssessmentsAssessmentIdRouteRoute
    }
    '/(dashboard)/admin/users/$userId/settings/': {
      id: '/(dashboard)/admin/users/$userId/settings/'
      path: '/settings'
      fullPath: '/admin/users/$userId/settings/'
      preLoaderRoute: typeof dashboardAdminUsersUserIdSettingsIndexRouteImport
      parentRoute: typeof dashboardAdminUsersUserIdRouteRoute
    }
    '/(dashboard)/admin/users/$userId/organizations/': {
      id: '/(dashboard)/admin/users/$userId/organizations/'
      path: '/organizations'
      fullPath: '/admin/users/$userId/organizations/'
      preLoaderRoute: typeof dashboardAdminUsersUserIdOrganizationsIndexRouteImport
      parentRoute: typeof dashboardAdminUsersUserIdRouteRoute
    }
    '/(dashboard)/admin/organizations/$organizationId/settings/': {
      id: '/(dashboard)/admin/organizations/$organizationId/settings/'
      path: '/settings'
      fullPath: '/admin/organizations/$organizationId/settings/'
      preLoaderRoute: typeof dashboardAdminOrganizationsOrganizationIdSettingsIndexRouteImport
      parentRoute: typeof dashboardAdminOrganizationsOrganizationIdRouteRoute
    }
    '/(dashboard)/admin/organizations/$organizationId/members/': {
      id: '/(dashboard)/admin/organizations/$organizationId/members/'
      path: '/members'
      fullPath: '/admin/organizations/$organizationId/members/'
      preLoaderRoute: typeof dashboardAdminOrganizationsOrganizationIdMembersIndexRouteImport
      parentRoute: typeof dashboardAdminOrganizationsOrganizationIdRouteRoute
    }
    '/(dashboard)/admin/organizations/$organizationId/billing/': {
      id: '/(dashboard)/admin/organizations/$organizationId/billing/'
      path: '/billing'
      fullPath: '/admin/organizations/$organizationId/billing/'
      preLoaderRoute: typeof dashboardAdminOrganizationsOrganizationIdBillingIndexRouteImport
      parentRoute: typeof dashboardAdminOrganizationsOrganizationIdRouteRoute
    }
  }
}

interface dashboardAssessmentsAssessmentIdRouteRouteChildren {
  dashboardAssessmentsAssessmentIdIndexRoute: typeof dashboardAssessmentsAssessmentIdIndexRoute
  dashboardAssessmentsAssessmentIdResponsesIdRoute: typeof dashboardAssessmentsAssessmentIdResponsesIdRoute
}

const dashboardAssessmentsAssessmentIdRouteRouteChildren: dashboardAssessmentsAssessmentIdRouteRouteChildren =
  {
    dashboardAssessmentsAssessmentIdIndexRoute:
      dashboardAssessmentsAssessmentIdIndexRoute,
    dashboardAssessmentsAssessmentIdResponsesIdRoute:
      dashboardAssessmentsAssessmentIdResponsesIdRoute,
  }

const dashboardAssessmentsAssessmentIdRouteRouteWithChildren =
  dashboardAssessmentsAssessmentIdRouteRoute._addFileChildren(
    dashboardAssessmentsAssessmentIdRouteRouteChildren,
  )

interface dashboardAssessmentsRouteRouteChildren {
  dashboardAssessmentsAssessmentIdRouteRoute: typeof dashboardAssessmentsAssessmentIdRouteRouteWithChildren
  dashboardAssessmentsIndexRoute: typeof dashboardAssessmentsIndexRoute
  dashboardAssessmentsDirectReportsIndexRoute: typeof dashboardAssessmentsDirectReportsIndexRoute
}

const dashboardAssessmentsRouteRouteChildren: dashboardAssessmentsRouteRouteChildren =
  {
    dashboardAssessmentsAssessmentIdRouteRoute:
      dashboardAssessmentsAssessmentIdRouteRouteWithChildren,
    dashboardAssessmentsIndexRoute: dashboardAssessmentsIndexRoute,
    dashboardAssessmentsDirectReportsIndexRoute:
      dashboardAssessmentsDirectReportsIndexRoute,
  }

const dashboardAssessmentsRouteRouteWithChildren =
  dashboardAssessmentsRouteRoute._addFileChildren(
    dashboardAssessmentsRouteRouteChildren,
  )

interface dashboardDirectReportsDirectReportIdRouteRouteChildren {
  dashboardDirectReportsDirectReportIdAssessmentsIndexRoute: typeof dashboardDirectReportsDirectReportIdAssessmentsIndexRoute
  dashboardDirectReportsDirectReportIdCareerPathIndexRoute: typeof dashboardDirectReportsDirectReportIdCareerPathIndexRoute
  dashboardDirectReportsDirectReportIdUserSettingsIndexRoute: typeof dashboardDirectReportsDirectReportIdUserSettingsIndexRoute
}

const dashboardDirectReportsDirectReportIdRouteRouteChildren: dashboardDirectReportsDirectReportIdRouteRouteChildren =
  {
    dashboardDirectReportsDirectReportIdAssessmentsIndexRoute:
      dashboardDirectReportsDirectReportIdAssessmentsIndexRoute,
    dashboardDirectReportsDirectReportIdCareerPathIndexRoute:
      dashboardDirectReportsDirectReportIdCareerPathIndexRoute,
    dashboardDirectReportsDirectReportIdUserSettingsIndexRoute:
      dashboardDirectReportsDirectReportIdUserSettingsIndexRoute,
  }

const dashboardDirectReportsDirectReportIdRouteRouteWithChildren =
  dashboardDirectReportsDirectReportIdRouteRoute._addFileChildren(
    dashboardDirectReportsDirectReportIdRouteRouteChildren,
  )

interface dashboardDirectReportsRouteRouteChildren {
  dashboardDirectReportsDirectReportIdRouteRoute: typeof dashboardDirectReportsDirectReportIdRouteRouteWithChildren
  dashboardDirectReportsIndexRoute: typeof dashboardDirectReportsIndexRoute
  dashboardDirectReportsInvitedIndexRoute: typeof dashboardDirectReportsInvitedIndexRoute
}

const dashboardDirectReportsRouteRouteChildren: dashboardDirectReportsRouteRouteChildren =
  {
    dashboardDirectReportsDirectReportIdRouteRoute:
      dashboardDirectReportsDirectReportIdRouteRouteWithChildren,
    dashboardDirectReportsIndexRoute: dashboardDirectReportsIndexRoute,
    dashboardDirectReportsInvitedIndexRoute:
      dashboardDirectReportsInvitedIndexRoute,
  }

const dashboardDirectReportsRouteRouteWithChildren =
  dashboardDirectReportsRouteRoute._addFileChildren(
    dashboardDirectReportsRouteRouteChildren,
  )

interface dashboardAdminOrganizationsOrganizationIdRouteRouteChildren {
  dashboardAdminOrganizationsOrganizationIdIndexRoute: typeof dashboardAdminOrganizationsOrganizationIdIndexRoute
  dashboardAdminOrganizationsOrganizationIdBillingIndexRoute: typeof dashboardAdminOrganizationsOrganizationIdBillingIndexRoute
  dashboardAdminOrganizationsOrganizationIdMembersIndexRoute: typeof dashboardAdminOrganizationsOrganizationIdMembersIndexRoute
  dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute: typeof dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute
}

const dashboardAdminOrganizationsOrganizationIdRouteRouteChildren: dashboardAdminOrganizationsOrganizationIdRouteRouteChildren =
  {
    dashboardAdminOrganizationsOrganizationIdIndexRoute:
      dashboardAdminOrganizationsOrganizationIdIndexRoute,
    dashboardAdminOrganizationsOrganizationIdBillingIndexRoute:
      dashboardAdminOrganizationsOrganizationIdBillingIndexRoute,
    dashboardAdminOrganizationsOrganizationIdMembersIndexRoute:
      dashboardAdminOrganizationsOrganizationIdMembersIndexRoute,
    dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute:
      dashboardAdminOrganizationsOrganizationIdSettingsIndexRoute,
  }

const dashboardAdminOrganizationsOrganizationIdRouteRouteWithChildren =
  dashboardAdminOrganizationsOrganizationIdRouteRoute._addFileChildren(
    dashboardAdminOrganizationsOrganizationIdRouteRouteChildren,
  )

interface dashboardAdminUsersUserIdRouteRouteChildren {
  dashboardAdminUsersUserIdIndexRoute: typeof dashboardAdminUsersUserIdIndexRoute
  dashboardAdminUsersUserIdOrganizationsIndexRoute: typeof dashboardAdminUsersUserIdOrganizationsIndexRoute
  dashboardAdminUsersUserIdSettingsIndexRoute: typeof dashboardAdminUsersUserIdSettingsIndexRoute
}

const dashboardAdminUsersUserIdRouteRouteChildren: dashboardAdminUsersUserIdRouteRouteChildren =
  {
    dashboardAdminUsersUserIdIndexRoute: dashboardAdminUsersUserIdIndexRoute,
    dashboardAdminUsersUserIdOrganizationsIndexRoute:
      dashboardAdminUsersUserIdOrganizationsIndexRoute,
    dashboardAdminUsersUserIdSettingsIndexRoute:
      dashboardAdminUsersUserIdSettingsIndexRoute,
  }

const dashboardAdminUsersUserIdRouteRouteWithChildren =
  dashboardAdminUsersUserIdRouteRoute._addFileChildren(
    dashboardAdminUsersUserIdRouteRouteChildren,
  )

interface dashboardRouteRouteChildren {
  dashboardAssessmentsRouteRoute: typeof dashboardAssessmentsRouteRouteWithChildren
  dashboardDirectReportsRouteRoute: typeof dashboardDirectReportsRouteRouteWithChildren
  dashboardIndexRoute: typeof dashboardIndexRoute
  dashboardAdminIndexRoute: typeof dashboardAdminIndexRoute
  dashboardPositionsIndexRoute: typeof dashboardPositionsIndexRoute
  dashboardSettingsIndexRoute: typeof dashboardSettingsIndexRoute
  dashboardAdminOrganizationsOrganizationIdRouteRoute: typeof dashboardAdminOrganizationsOrganizationIdRouteRouteWithChildren
  dashboardAdminUsersUserIdRouteRoute: typeof dashboardAdminUsersUserIdRouteRouteWithChildren
  dashboardPositionsIdQuestionsRoute: typeof dashboardPositionsIdQuestionsRoute
  dashboardAdminOrganizationsIndexRoute: typeof dashboardAdminOrganizationsIndexRoute
  dashboardAdminUsersIndexRoute: typeof dashboardAdminUsersIndexRoute
  dashboardAnalyticsOverviewIndexRoute: typeof dashboardAnalyticsOverviewIndexRoute
  dashboardAnalyticsStatisticsIndexRoute: typeof dashboardAnalyticsStatisticsIndexRoute
  dashboardOrganizationBillingIndexRoute: typeof dashboardOrganizationBillingIndexRoute
  dashboardOrganizationInvitesIndexRoute: typeof dashboardOrganizationInvitesIndexRoute
  dashboardOrganizationOverviewIndexRoute: typeof dashboardOrganizationOverviewIndexRoute
  dashboardOrganizationSettingsIndexRoute: typeof dashboardOrganizationSettingsIndexRoute
}

const dashboardRouteRouteChildren: dashboardRouteRouteChildren = {
  dashboardAssessmentsRouteRoute: dashboardAssessmentsRouteRouteWithChildren,
  dashboardDirectReportsRouteRoute:
    dashboardDirectReportsRouteRouteWithChildren,
  dashboardIndexRoute: dashboardIndexRoute,
  dashboardAdminIndexRoute: dashboardAdminIndexRoute,
  dashboardPositionsIndexRoute: dashboardPositionsIndexRoute,
  dashboardSettingsIndexRoute: dashboardSettingsIndexRoute,
  dashboardAdminOrganizationsOrganizationIdRouteRoute:
    dashboardAdminOrganizationsOrganizationIdRouteRouteWithChildren,
  dashboardAdminUsersUserIdRouteRoute:
    dashboardAdminUsersUserIdRouteRouteWithChildren,
  dashboardPositionsIdQuestionsRoute: dashboardPositionsIdQuestionsRoute,
  dashboardAdminOrganizationsIndexRoute: dashboardAdminOrganizationsIndexRoute,
  dashboardAdminUsersIndexRoute: dashboardAdminUsersIndexRoute,
  dashboardAnalyticsOverviewIndexRoute: dashboardAnalyticsOverviewIndexRoute,
  dashboardAnalyticsStatisticsIndexRoute:
    dashboardAnalyticsStatisticsIndexRoute,
  dashboardOrganizationBillingIndexRoute:
    dashboardOrganizationBillingIndexRoute,
  dashboardOrganizationInvitesIndexRoute:
    dashboardOrganizationInvitesIndexRoute,
  dashboardOrganizationOverviewIndexRoute:
    dashboardOrganizationOverviewIndexRoute,
  dashboardOrganizationSettingsIndexRoute:
    dashboardOrganizationSettingsIndexRoute,
}

const dashboardRouteRouteWithChildren = dashboardRouteRoute._addFileChildren(
  dashboardRouteRouteChildren,
)

interface InvitesBlankRouteChildren {
  InvitesBlankIdConfirmRoute: typeof InvitesBlankIdConfirmRoute
}

const InvitesBlankRouteChildren: InvitesBlankRouteChildren = {
  InvitesBlankIdConfirmRoute: InvitesBlankIdConfirmRoute,
}

const InvitesBlankRouteWithChildren = InvitesBlankRoute._addFileChildren(
  InvitesBlankRouteChildren,
)

interface InvitesRouteRouteChildren {
  InvitesBlankRoute: typeof InvitesBlankRouteWithChildren
}

const InvitesRouteRouteChildren: InvitesRouteRouteChildren = {
  InvitesBlankRoute: InvitesBlankRouteWithChildren,
}

const InvitesRouteRouteWithChildren = InvitesRouteRoute._addFileChildren(
  InvitesRouteRouteChildren,
)

interface OnboardingBlankRouteChildren {
  OnboardingBlankAssignPositionRoute: typeof OnboardingBlankAssignPositionRoute
  OnboardingBlankIndexRoute: typeof OnboardingBlankIndexRoute
}

const OnboardingBlankRouteChildren: OnboardingBlankRouteChildren = {
  OnboardingBlankAssignPositionRoute: OnboardingBlankAssignPositionRoute,
  OnboardingBlankIndexRoute: OnboardingBlankIndexRoute,
}

const OnboardingBlankRouteWithChildren = OnboardingBlankRoute._addFileChildren(
  OnboardingBlankRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  dashboardRouteRoute: dashboardRouteRouteWithChildren,
  InvitesRouteRoute: InvitesRouteRouteWithChildren,
  CallbackRoute: CallbackRoute,
  SignInRoute: SignInRoute,
  OnboardingBlankRoute: OnboardingBlankRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
